import React from "react";
import Grid from "@mui/material/Grid2";
import { Typography, Paper, Box } from "@mui/material";
import CaseStudy3 from "../../../images/CaseStudy3.png";
import CaseStudy4 from "../../../images/CaseStudy4.png";

const ApplicationsBlockRTL: any = (props: any) => {
  const { pageData } = props;

  return (
    <Box
      pt={2}
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        zIndex: 1,
        backgroundPosition: "inherit",
        width: "100%",
      }}
    >
      <Grid
        container
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          padding: { xs: "5px", sm: "5px", md: "0px" },
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* Image section - Now on the left */}
        <Grid
          size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
          sx={{
            position: "relative",
            alignItems: "center",
            order: { xs: 1, md: 2 },
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "20px", md: 0 },
          }}
        >
          <Box
            sx={{
              width: { xs: "60%", md: "40%" },
              position: "absolute",
              top: 0,
              left: 0,
              height: "100%",
              backgroundColor: "#0065FF",
              zIndex: 1,

              // width: { xs: "60%", md: "40%" },
            }}
          />
          <Box
            sx={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              zIndex: 2,
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <Box
              component="img"
              src={
                pageData?.solutionsDetails?.blogBlock2?.leftSideContent &&
                pageData?.solutionsDetails?.blogBlock2?.leftSideContent
                  .images?.[0]?.url
                  ? process.env.REACT_APP_API_BASE_URL +
                    pageData.solutionsDetails.blogBlock2.leftSideContent
                      .images[0].url
                  : CaseStudy3
              }
              alt="Application 1"
              sx={{
                padding: 2,
                maxWidth: 600,
                width: "100%",
                objectFit: "contain",
                mt: { xs: "15px", md: "15px", lg: 0 },
              }}
            />
            <Box
              component="img"
              src={
                pageData?.solutionsDetails?.blogBlock2?.leftSideContent &&
                pageData?.solutionsDetails?.blogBlock2?.leftSideContent
                  .images?.[1]?.url
                  ? process.env.REACT_APP_API_BASE_URL +
                    pageData.solutionsDetails.blogBlock2.leftSideContent
                      .images[1].url
                  : CaseStudy4
              }
              alt="Application 2"
              sx={{
                padding: 2,
                maxWidth: 600,
                width: "100%",
                objectFit: "contain",
                mt: { xs: "15px", md: "15px", lg: 0 },
              }}
            />
          </Box>
        </Grid>

        {/* Application text section - Now on the right */}
        <Grid
          size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
          sx={{
            order: { xs: 1, md: 2 },
            padding: { xs: "20px", md: "40px" },
            position: "relative",
          }}
        >
          <Typography
            variant="body1"
            sx={{ color: "#0A1A3C", fontSize: "17px", lineHeight: 1.6 }}
            dangerouslySetInnerHTML={{
              __html: pageData?.solutionsDetails?.blogBlock2?.rightSideContent
                ?.description
                ? pageData?.solutionsDetails?.blogBlock2?.rightSideContent
                    ?.description
                : "",
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ApplicationsBlockRTL;
